module.exports = __webpack_public_path__ + "static/media/deleteRow.1deee26c.svg";